(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("CaseImportDialogController", CaseImportDialogController);

    CaseImportDialogController.$inject = ["CaseImport", "$timeout", "$state","previousState"];
    function CaseImportDialogController(CaseImport, $timeout, $state,previousState) {
        var vm = this;
        var getFile, lastDotPosition, format;
        vm.currentState = previousState

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        vm.onSubmit = function () {
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                CaseImport.get(
                    {
                        entityName: vm.entity,
                        entityLayout: vm.entityLayout,
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 500);
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };
    }
})();
